import {pathResolver} from '../utils/basePathHelper';

const DepositorIcon = () => (
  <img
    alt="depositor"
    src={pathResolver('resources/svg/depositor.svg')}
    height={200}
  />
);

export default DepositorIcon;
